// src/api/pagoServicio.js
import { apiFetch } from './index.js';

// ============================================================
//  CRUD PAGO SERVICIO
// ============================================================

export const obtenerPagos = async () => {
  try {
    const response = await apiFetch('/api/PagoServicio');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    console.error('❌ Error obteniendo pagos:', error);
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPagoPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/${id}`);
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerPagosPorContrato = async (idContratoServicio) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/contrato/${idContratoServicio}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPagosPorEstado = async (estado) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/estado/${estado}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPagosPorPeriodo = async (periodo) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/periodo/${encodeURIComponent(periodo)}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPagosPorServicioPublico = async (idServicioPublico) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/servicio/${idServicioPublico}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const crearPago = async (data) => {
  try {
    const response = await apiFetch('/api/PagoServicio', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const actualizarPago = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const eliminarPago = async (id) => {
  try {
    await apiFetch(`/api/PagoServicio/${id}`, { method: 'DELETE' });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const registrarPago = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/${id}/pagar`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const anularPago = async (id, motivo) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/${id}/anular`, {
      method: 'POST',
      body: JSON.stringify(motivo)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const buscarPagos = async (filtros) => {
  try {
    const response = await apiFetch('/api/PagoServicio/search', {
      method: 'POST',
      body: JSON.stringify(filtros)
    });
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

// ============================================================
//  ALERTAS Y RESUMEN
// ============================================================

export const obtenerPagosProximosAVencer = async (dias = 7) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/proximos-vencer?dias=${dias}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPagosVencidos = async () => {
  try {
    const response = await apiFetch('/api/PagoServicio/vencidos');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerResumenPagos = async () => {
  try {
    const response = await apiFetch('/api/PagoServicio/resumen');
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerAlertas = async () => {
  try {
    const response = await apiFetch('/api/PagoServicio/alertas');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

// ============================================================
//  GENERACIÓN AUTOMÁTICA
// ============================================================

export const generarPagoDesdeContrato = async (idContratoServicio, periodo) => {
  try {
    const response = await apiFetch(`/api/PagoServicio/generar/${idContratoServicio}?periodo=${encodeURIComponent(periodo)}`, {
      method: 'POST'
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const generarPagosMensuales = async () => {
  try {
    const response = await apiFetch('/api/PagoServicio/generar-mensuales', { method: 'POST' });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// ============================================================
//  CONSTANTES Y HELPERS DE UI
// ============================================================

export const ESTADOS_PAGO = [
  { value: 'pendiente', label: 'Pendiente', color: 'amber' },
  { value: 'pagado', label: 'Pagado', color: 'emerald' },
  { value: 'vencido', label: 'Vencido', color: 'red' },
  { value: 'parcial', label: 'Parcial', color: 'orange' },
  { value: 'anulado', label: 'Anulado', color: 'gray' }
];

export const METODOS_PAGO = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'transferencia', label: 'Transferencia' },
  { value: 'pago_movil', label: 'Pago Móvil' },
  { value: 'zelle', label: 'Zelle' },
  { value: 'punto', label: 'Punto de Venta' },
  { value: 'otro', label: 'Otro' }
];

export const getEstadoPagoInfo = (estado) => {
  return ESTADOS_PAGO.find(e => e.value === estado) || ESTADOS_PAGO[0];
};

export const formatearMoneda = (valor) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(valor || 0);
};

export const formatearFecha = (fecha) => {
  if (!fecha) return 'N/A';
  try {
    return new Date(fecha).toLocaleDateString('es-VE', {
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
  } catch {
    return fecha;
  }
};

export const calcularDiasRestantes = (fechaVencimiento) => {
  if (!fechaVencimiento) return 0;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const venc = new Date(fechaVencimiento);
  venc.setHours(0, 0, 0, 0);
  return Math.ceil((venc - hoy) / (1000 * 60 * 60 * 24));
};

export const formatearPeriodo = (periodo) => {
  if (!periodo) return '';
  if (/^\d{4}-\d{2}$/.test(periodo)) {
    const [anio, mes] = periodo.split('-');
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                   'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    return `${meses[parseInt(mes) - 1]} ${anio}`;
  }
  return periodo;
};

export default {
  // CRUD
  obtenerPagos,
  obtenerPagoPorId,
  obtenerPagosPorContrato,
  obtenerPagosPorEstado,
  obtenerPagosPorPeriodo,
  obtenerPagosPorServicioPublico,
  crearPago,
  actualizarPago,
  eliminarPago,
  registrarPago,
  anularPago,
  buscarPagos,
  // Alertas
  obtenerPagosProximosAVencer,
  obtenerPagosVencidos,
  obtenerResumenPagos,
  obtenerAlertas,
  // Generación
  generarPagoDesdeContrato,
  generarPagosMensuales,
  // Constantes
  ESTADOS_PAGO,
  METODOS_PAGO,
  // Helpers
  getEstadoPagoInfo,
  formatearMoneda,
  formatearFecha,
  calcularDiasRestantes,
  formatearPeriodo
};